var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 396.49 342.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff6392;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.98,129.16c4.55-43.14-8.93-86.2-42.56-129.16-22.09,2.58-43.5,12.34-60.45,29.29C2.93,56.33-5.81,94.75,3.74,129.16H132.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.75,129.16h81.09V15.48c-6.07,3.9-11.82,8.49-17.13,13.8l-23.46,23.46-23.46-23.46c-5.28-5.28-11-9.86-17.04-13.74v113.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.58,152.73c6.66,26.78,20.12,53.59,39.87,80.43l35.61-35.61,23.46-23.46c6.53-6.53,11.98-13.72,16.38-21.36h-115.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.49,129.16h129.26c9.55-34.41,.8-72.83-26.24-99.88C349.8,12.57,328.73,2.85,306.96,.11c-33.92,42.93-47.7,85.95-43.47,129.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.13,232.04c19.48-26.47,32.83-52.9,39.59-79.31H13.6c4.4,7.64,9.85,14.83,16.38,21.36l23.46,23.46,35.81,35.81c-.07-.42-.12-.86-.13-1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.6,244.98c-12.57,0-22.76-5.28-22.76-11.8v-80.45h-81.09v79.31c0,6.52-10.19,11.8-22.76,11.8-8.26-.03-27.53,1.26-38.28-3.02l101.53,101.53,99.72-99.72c-10.99,3.45-28.58,2.31-36.37,2.34Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e2133164d612ba2085bfca7a4ea0b125.svg";
export { ForwardRef as ReactComponent };